<template>
  <div v-if="isOpen" class="modal-overlay" @click="closeModal">
    <div
      class="modal-card"
      @click.stop
    >
      <button
        class="clear-button absolute-top-right"
        data-test="close-modal"
        @click="closeModal"
      >
        <icon name="close-x" variant="98A2B3" />
      </button>
      <div class="header">
        <slot name="header">
        </slot>
      </div>
      <div class="container">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  name: 'BaseModal',
  components: {
    Icon,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  padding-left: rem-calc(20);
  border-bottom: 1px solid var(--border-primary);
}

.container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: rem-calc(20);
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 950;
}

.modal-card {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
  background-color: rgb(250, 250, 250);
  color: rgba(71, 84, 103, 1);
  min-width: 100%;
  min-height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  font-size: var(--Fontsizetext-md);
  line-height: var(--Lineheighttext-md);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.absolute-top-right {
  position: absolute;
  top: 20px;
  right: 20px;
}

.clear-button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
}

@include breakpoint(tablet) {
  .absolute-top-right {
    top: rem-calc(28);
    right: rem-calc(16);
  }

  .modal-card {
    max-width: clamp(0px, 90vw, 600px);
    max-height: clamp(0px, 90vh, 800px);
    min-width: 0;
    min-height: 724px;
    background-color: rgb(245, 245, 245);
    border-radius: 12px;
  }
}

@include breakpoint(desktop) {
  .absolute-top-right {
    top: rem-calc(28);
    right: rem-calc(16);
  }
  .modal-card {
    min-height: 724px;
    min-width: 0;
    max-width: clamp(0px, 90vw, 600px);
    max-height: 800px;
    background-color: rgb(245, 245, 245);
    border-radius: 12px;
  }
}
</style>
